/**
 * Shared Arabic-collated organization sort.
 *
 * Single source of truth for "first org alphabetically" — the
 * OrganizationFilterDropdown displays orgs in this order and
 * EmployeesScreen auto-selects the first entry of the same order, so both
 * MUST sort identically (codepoint sort misplaces hamza variants; the
 * collator doesn't).
 */

const arabicCollator = new Intl.Collator('ar');

export function sortOrgsByArabicName<T extends { name: string }>(orgs: readonly T[]): T[] {
  return [...orgs].sort((a, b) => arabicCollator.compare(a.name, b.name));
}
